export const buildDateKey = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const normalizeDateKey = (value) => {
  if (!value) return "";
  const normalized = String(value).substring(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(normalized) ? normalized : "";
};

export const parseDateKey = (value) => {
  const normalized = normalizeDateKey(value);
  if (!normalized) return null;
  const [year, month, day] = normalized.split("-").map(Number);
  const date = new Date(year, month - 1, day, 12, 0, 0, 0);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const addDays = (date, amount) => {
  const base = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0, 0);
  base.setDate(base.getDate() + amount);
  return base;
};

export const formatCalendarMonth = (date) => date.toLocaleDateString("pt-BR", { month: "long" }).toUpperCase();

export const formatShortWeekday = (date) => date.toLocaleDateString("pt-BR", { weekday: "short" }).replace(".", "").toUpperCase();

export const formatDisplayDate = (value) => {
  if (!value) return "—";
  const date = parseDateKey(value) || new Date(`${String(value).substring(0, 10)}T12:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
};
